import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { GeoJSON, withLeaflet } from 'react-leaflet';
import Chroma from 'chroma-js'

import { is768Query } from '~/core/scripts/mediaquery-helper';
import { getPartyColor, partyConfig } from '~/scripts/config';

import './ChoroplethLayer.styl';

function getColorItem(partyItem, selectedParty) {
  if (selectedParty) {
    return getPartyColor(selectedParty);
  }

  if (partyItem) {
    return partyItem.color;
  }

  return partyConfig.default;
}

function getColor(props, selectedParty, selectedAnalysis) {
  let partyItem = props.partyItems[0];
  let valueKey = 'valueRel';
  const analysisName = selectedAnalysis.name;

  if (analysisName === 'secondplace') {
    partyItem = props.partyItems[1];
  }

  if (analysisName === 'thirdplace') {
    partyItem = props.partyItems[2];
  }

  if (analysisName === 'true') {
    if (props.nonVotersRel > partyItem.valueRel) {
      partyItem = {
        valueRel: props.nonVotersRel,
        name: 'nichtwaehler',
        color: getPartyColor('nichtwaehler')
      };
    }
  }

  if (analysisName === 'close') {
    partyItem = props.isClose ?  props.partyItems[0] : null;
  }

  if (analysisName === 'change') {
    partyItem = props.partyItems[0].name !== props.winnerItemComp.name ? props.partyItems[0] : null;
  }

  if (analysisName === 'idfilter') {
    partyItem = selectedAnalysis.ids.includes(props.Wahlgebiet_ID) ? props.partyItems[0] : null;
  }

  if (selectedParty && selectedParty !== 'Sonst.') {
    partyItem = props.partyItems.find(d => d.name === selectedParty);
  }

  if (selectedParty === 'Sonst.') {
    partyItem = props.othersItem;
  }

  const colorItem = getColorItem(partyItem, selectedParty);
  const fillColor = partyItem ? Chroma.scale([colorItem.min, colorItem.max]).domain([0, 45], 10)(partyItem[valueKey]) : partyConfig.default.max;

  return fillColor;
}


class Choropleth extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    onMouseEnter: PropTypes.func,
    onMouseMove: PropTypes.func,
    onMouseOut: PropTypes.func,
    smoothFactor: PropTypes.number
  }

  static defaultProps = {
    data: null,
    onMouseEnter: () => {},
    onMouseMove: () => {},
    onMouseOut: () => {},
    smoothFactor: 0.5
  }

  getMouseOverHandler = (layer, props) => () => {
    layer.setStyle({ weight: 1 });

    if (layer.bringToFront) {
      layer.bringToFront();
    }

    this.props.onMouseEnter(layer.feature.properties);
  }

  getMouseOutHandler = (layer, props) => () => {
    layer.setStyle({ weight: 0.5 });

    if (layer.bringToBack) {
      layer.bringToBack();
    }

    this.props.onMouseOut(null);
  }

  getMouseMoveHandler = (layer, props) => (evt) => {
    const { containerPoint } = evt;

    this.props.onMouseMove(containerPoint);
  }

  getClickHandler = (layer, props) => (evt) => {
    const { containerPoint } = evt;
    layer.setStyle({ weight: 1 });

    if (layer.bringToFront) {
      layer.bringToFront();
    }

    this.props.onClick(layer.feature.properties, containerPoint);
  }

  onEachFeature = (feat, layer) => {
    const { properties } = feat;

    if (is768Query()) {
      layer.on('mouseover', this.getMouseOverHandler(layer, properties));
      layer.on('mouseout', this.getMouseOutHandler(layer, properties));
      layer.on('mousemove', this.getMouseMoveHandler(layer, properties));
    }

    if (feat.properties.hasData) {
      layer.on('click', this.getClickHandler(layer, properties));
    }

    layer.setStyle({ className: 'choropleth-layer' });
  }

  getStyle(feat) {
    const color = getColor(feat.properties, this.props.selectedParty, this.props.selectedAnalysis);

    return {
      color,
      weight: 0.5,
      fillColor: color,
      fillOpacity: 0.8
    };
  }

  render() {
    if (!this.props.data) {
      return null;
    }

    return (
      <GeoJSON
        key={`geodata__${this.props.data.features.length}`}
        data={this.props.data}
        onEachFeature={this.onEachFeature}
        className="electionmap__choropleth"
        style={(feat) => this.getStyle(feat)}
        smoothFactor={this.props.smoothFactor}
      />
    );
  }
}

export default withLeaflet(Choropleth);
